import type {UseFormReturn} from 'react-hook-form';
import {useTranslation} from 'react-i18next';

import {ColorPicker} from '@/components/ui/color-picker';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  FormRequiredLegend,
} from '@/components/ui/form';
import {Input} from '@/components/ui/input';

import {JOB_ROLE_COLORS} from '../utils/jobRoleColors';
import type {JobRoleFormValues} from '../utils/jobRoleFormInputs';

export type JobRoleFormFieldsProps = {
  form: UseFormReturn<JobRoleFormValues>;
};

const JobRoleFormFields = ({form}: JobRoleFormFieldsProps) => {
  const {t} = useTranslation();

  return (
    <>
      <FormRequiredLegend />
      <FormField
        control={form.control}
        name="name"
        render={({field}) => (
          <FormItem>
            <FormLabel required>{t('Role name')}</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="color"
        render={({field}) => (
          <FormItem>
            <FormLabel required>{t('Color')}</FormLabel>
            <FormControl>
              <ColorPicker
                colors={[...JOB_ROLE_COLORS]}
                value={field.value}
                onValueChange={field.onChange}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};

export default JobRoleFormFields;
